module.exports = __webpack_public_path__ + "img/appAsset--branch-ax.903ca12f.svg";